import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getFLFCategory } from "src/apis/FLF/category.api";
import { getFLFIotPartner } from "src/apis/FLF/iotPartner.api";
import Controls from "src/components/form/controls/Controls";

const DevicePanelOptional = ({
  iotPartnerId,
  onChangeIotPartner,
  categoryId,
  onChangeCategory,
}) => {
  const [iotPartners, setIotPartners] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getFLFIotPartner({}, (result) => {
      setIotPartners([{ id: "all", partnerName: "All" }, ...result.list]);
    });

    getFLFCategory({}, (result) => {
      setCategories([{ id: "all", name: "All" }, ...result.list]);
    });
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="iotPartnerId"
        label="Iot partner"
        value={iotPartnerId}
        onChange={(e) => onChangeIotPartner(e.target.value)}
        options={iotPartners.map((iotPartner) => ({
          ...iotPartner,
          name: iotPartner.partnerName,
        }))}
        searchable={true}
        style={{ width: "150px", marginRight: "10px" }}
      />
      <Controls.Select
        name="categoryId"
        label="Categories"
        value={categoryId}
        onChange={(e) => onChangeCategory(e.target.value)}
        options={categories}
        searchable={true}
        style={{ width: "200px" }}
      />
    </div>
  );
};

export default DevicePanelOptional;
